// import {
//     fadeIn,
// } from '@js/common/customFunctions.js';
// import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';

// document.addEventListener('DOMContentLoaded', () => {
//     const issSldier = document.querySelectorAll('.full-width-image-tabs-section');

//     issSldier.forEach(section => {
//         const issTabSldier = section.querySelector('.fwits-tab-slider');
//         const issContentSldier = section.querySelector('.fwits-content-slider');

//         const mainTabSwiper = new Swiper(issTabSldier, {
//             slidesPerView: 'auto',
//             spaceBetween: 34,
//         });

//         const mainContentSwiper = new Swiper(issContentSldier, {
//             slidesPerView: 1,
//             spaceBetween: 24,
//             // effect: 'fade',
//             autoHeight: true,
//             allowTouchMove: false,
//             fadeEffect: {
//                 crossFade: true,
//             },
//             navigation: {
//                 prevEl: section.querySelector('.fwits-button-prev'),
//                 nextEl: section.querySelector('.fwits-button-next'),
//             },
//             pagination: {
//                 el: section.querySelector('.fwits-pagination'),
//                 type: 'fraction',
//                 renderFraction: function(currentClass, totalClass) {
//                     return '<span class="' + currentClass + '"></span> of <span class="' + totalClass + '"></span>';
//                 },
//             },
//         });

//         // Add click handlers to fwits-tab-item inside this section
//         const cpqCards = section.querySelectorAll('.fwits-tab-item');
//         const items = section.querySelectorAll('.fwits-img-item');
//         let currentActiveItem = null;
//         cpqCards.forEach((card, index) => {
//             card.addEventListener('click', () => {
//                 const targetId = card.getAttribute('data-href');

//                 if (!card.classList.contains('is-active')) {
//                     const targetId = card.getAttribute('data-id');

//                     // Update card active state
//                     cpqCards.forEach(c => c.classList.remove('is-active'));
//                     card.classList.add('is-active');

//                     const newItem = Array.from(items).find(item =>
//                         item.getAttribute('data-id') === targetId,
//                     );

//                     // Remove animation classes in case they exist
//                     if (newItem) {
//                         newItem.classList.remove('slide-in', 'slide-out', 'exit');
//                     }

//                     // Handle previous active item (if any)
//                     if (currentActiveItem && currentActiveItem !== newItem) {
//                         currentActiveItem.classList.remove('slide-in');
//                         currentActiveItem.classList.add('slide-out');

//                         setTimeout(() => {
//                             currentActiveItem.classList.remove('is-active', 'slide-out');
//                             currentActiveItem.classList.add('exit');
//                         }, 500); // Match the animation duration
//                     }

//                     // Activate new item
//                     if (newItem) {
//                         newItem.classList.remove('exit');
//                         newItem.classList.add('is-active', 'slide-in');
//                         currentActiveItem = newItem;
//                     }
//                 }

//                 mainContentSwiper.slideTo(index);
//             });
//         });

//         const imgItems = section.querySelectorAll('.fwits-img-item');
//         const contentSidebar = section.querySelector('.fwits-content-sidebar');

//         imgItems.forEach(item => {
//             const dragElements = item.querySelectorAll('.drag_element');
//             dragElements.forEach(dragEl => {
//                 dragEl.addEventListener('click', () => {
//                     if (contentSidebar) {
//                         contentSidebar.classList.add('is-show');
//                     }
//                 });
//             });
//         });

//         const closeBtns = section.querySelectorAll('.fwits-content-sidebar .close-btn, .fwits-content-sidebar .fwits-overlay');
//         if (contentSidebar && closeBtns.length) {
//             closeBtns.forEach(btn => {
//                 btn.addEventListener('click', () => {
//                     contentSidebar.classList.remove('is-show');
//                 });
//             });
//         }

//         mainContentSwiper.on('slideChange', () => {
//             const currentIndex = mainContentSwiper.activeIndex;

//             cpqCards.forEach(c => c.classList.remove('is-active'));
//             if (cpqCards[currentIndex]) {
//                 cpqCards[currentIndex].classList.add('is-active');
//             }

//             // Also update visible image items if needed
//             // const targetId = cpqCards[currentIndex] ?.getAttribute('data-href');
//             // items.forEach(item => {
//             //     item.style.display = item.getAttribute('data-id') === targetId ? fadeIn(item) : 'none';
//             // });

//             // Slide tab slider to active tab to keep it visible
//             mainTabSwiper.slideTo(currentIndex);
//         });
//     });



//     const items = document.querySelectorAll('.fwits-img-item');
//     const tabs = document.querySelectorAll('.fwits-tab-item'); // your tabs

//     tabs.forEach((tab, index) => {
//         tab.addEventListener('click', () => {
//             const current = document.querySelector('.fwits-img-item.is-active');

//             // If clicked item is already active → slide out
//             if (current === items[index]) {
//                 current.classList.remove('is-active');
//                 current.classList.add('exit');

//                 setTimeout(() => current.classList.remove('exit'), 800);
//                 return;
//             }

//             // Slide out current active
//             if (current) {
//                 current.classList.remove('is-active');
//                 current.classList.add('exit');
//                 setTimeout(() => current.classList.remove('exit'), 800);
//             }

//             // Slide in clicked item
//             items[index].classList.add('is-active');
//         });
//     });
// });






// import { fadeIn } from '@js/common/customFunctions.js';
// import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';

// document.addEventListener('DOMContentLoaded', () => {
//     const sections = document.querySelectorAll('.full-width-image-tabs-section');

//     sections.forEach(section => {
//         const tabSliderEl = section.querySelector('.fwits-tab-slider');
//         const contentSliderEl = section.querySelector('.fwits-content-slider');
//         const cpqCards = section.querySelectorAll('.fwits-tab-item');
//         const imgItems = section.querySelectorAll('.fwits-img-item');
//         const contentSidebar = section.querySelector('.fwits-content-sidebar');

//         let currentActiveItem = section.querySelector('.fwits-img-item.is-active');

//         // Initialize Swipers
//         const tabSwiper = new Swiper(tabSliderEl, {
//             slidesPerView: 'auto',
//             spaceBetween: 34,
//         });

//         const contentSwiper = new Swiper(contentSliderEl, {
//             slidesPerView: 1,
//             spaceBetween: 24,
//             autoHeight: true,
//             allowTouchMove: false,
//             fadeEffect: { crossFade: true },
//             navigation: {
//                 prevEl: section.querySelector('.fwits-button-prev'),
//                 nextEl: section.querySelector('.fwits-button-next'),
//             },
//             pagination: {
//                 el: section.querySelector('.fwits-pagination'),
//                 type: 'fraction',
//                 clickable: true,
//                 renderFraction: function(currentClass, totalClass) {
//                     return '<span class="' + currentClass + '"></span> of <span class="' + totalClass + '"></span>';
//                 },
//             },
//         });

//         // Function to update active image item
//         function updateImageItem(index) {
//             const newItem = imgItems[index];

//             if (currentActiveItem && currentActiveItem !== newItem) {
//                 currentActiveItem.classList.remove('is-active');
//             }

//             if (newItem) {
//                 newItem.classList.add('is-active');
//                 currentActiveItem = newItem;
//             }
//         }

//         // TAB click
//         cpqCards.forEach((card, index) => {
//             card.addEventListener('click', () => {
//                 if (!card.classList.contains('is-active')) {
//                     // Update tab active state
//                     cpqCards.forEach(c => c.classList.remove('is-active'));
//                     card.classList.add('is-active');

//                     // Update content slider
//                     contentSwiper.slideTo(index);

//                     // Update image item
//                     updateImageItem(index);
//                 }
//             });
//         });

//         // Update tabs & images on slide change (pagination, arrows)
//         contentSwiper.on('slideChange', () => {
//             const currentIndex = contentSwiper.activeIndex;

//             // Update tab active state
//             cpqCards.forEach(c => c.classList.remove('is-active'));
//             if (cpqCards[currentIndex]) {cpqCards[currentIndex].classList.add('is-active');}

//             // Slide tab swiper to keep active tab visible
//             tabSwiper.slideTo(currentIndex);

//             // Update image items
//             updateImageItem(currentIndex);
//         });

//         // Image drag elements click → show sidebar
//         imgItems.forEach(item => {
//             const dragElements = item.querySelectorAll('.drag_element');
//             dragElements.forEach(dragEl => {
//                 dragEl.addEventListener('click', () => {
//                     if (contentSidebar) {contentSidebar.classList.add('is-show');}
//                 });
//             });
//         });

//         // Close sidebar
//         const closeBtns = section.querySelectorAll('.fwits-content-sidebar .close-btn, .fwits-content-sidebar .fwits-overlay');
//         if (contentSidebar && closeBtns.length) {
//             closeBtns.forEach(btn => {
//                 btn.addEventListener('click', () => {
//                     contentSidebar.classList.remove('is-show');
//                 });
//             });
//         }
//     });
// });


// import {
//     fadeIn,
// } from '@js/common/customFunctions.js';
// import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';

// document.addEventListener('DOMContentLoaded', () => {
//     const sections = document.querySelectorAll('.full-width-image-tabs-section');

//     sections.forEach(section => {
//         const tabSliderEl = section.querySelector('.fwits-tab-slider');
//         const contentSliderEl = section.querySelector('.fwits-content-slider');
//         const tabs = section.querySelectorAll('.fwits-tab-item');
//         const images = section.querySelectorAll('.fwits-img-item');
//         const contentSidebar = section.querySelector('.fwits-content-sidebar');

//         let currentActiveImage = section.querySelector('.fwits-img-item.is-active') || null;

//         // Initialize Swipers
//         const tabSwiper = new Swiper(tabSliderEl, {
//             slidesPerView: 'auto',
//             spaceBetween: 34,
//         });

//         const contentSwiper = new Swiper(contentSliderEl, {
//             slidesPerView: 1,
//             spaceBetween: 24,
//             autoHeight: true,
//             allowTouchMove: false,
//             fadeEffect: {
//                 crossFade: true,
//             },
//             navigation: {
//                 prevEl: section.querySelector('.fwits-button-prev'),
//                 nextEl: section.querySelector('.fwits-button-next'),
//             },
//             pagination: {
//                 el: section.querySelector('.fwits-pagination'),
//                 type: 'fraction',
//                 renderFraction: function(currentClass, totalClass) {
//                     return '<span class="' + currentClass + '"></span> of <span class="' + totalClass + '"></span>';
//                 },
//             },
//         });

//         // Function to update active image with exit logic
//         function setActiveImage(index) {
//             const newImage = images[index];
//             if (!newImage) {
//                 return;
//             }

//             // Remove old exit classes
//             images.forEach(img => img.classList.remove('exit'));

//             // Mark previous active as exit
//             if (currentActiveImage && currentActiveImage !== newImage) {
//                 currentActiveImage.classList.remove('is-active', 'slide-in');
//                 currentActiveImage.classList.add('exit');
//             }

//             // Activate new image
//             newImage.classList.add('is-active', 'slide-in');
//             setTimeout(() => {
//                 newImage.classList.remove('slide-in');
//             }, 500); // match your CSS animation duration

//             currentActiveImage = newImage;
//         }

//         // Tab click
//         tabs.forEach((tab, index) => {
//             tab.addEventListener('click', () => {
//                 if (tab.classList.contains('is-active')) {
//                     return;
//                 }

//                 tabs.forEach(t => t.classList.remove('is-active'));
//                 tab.classList.add('is-active');

//                 // Slide in clicked item
//                 contentSwiper.slideTo(index);
//             });
//         });

//         // Content Swiper change (arrows/pagination)
//         contentSwiper.on('slideChange', () => {
//             const currentIndex = contentSwiper.activeIndex;

//             tabs.forEach(t => t.classList.remove('is-active'));
//             if (tabs[currentIndex]) {
//                 tabs[currentIndex].classList.add('is-active');
//             }

//             setActiveImage(currentIndex);
//             tabSwiper.slideTo(currentIndex);
//         });

//         // Open/close sidebar on drag element click
//         images.forEach(item => {
//             const dragElements = item.querySelectorAll('.drag_element');
//             dragElements.forEach(dragEl => {
//                 dragEl.addEventListener('click', () => {
//                     if (contentSidebar) {
//                         contentSidebar.classList.add('is-show');
//                     }
//                 });
//             });
//         });

//         const closeBtns = section.querySelectorAll('.fwits-content-sidebar .close-btn, .fwits-content-sidebar .fwits-overlay');
//         if (contentSidebar && closeBtns.length) {
//             closeBtns.forEach(btn => {
//                 btn.addEventListener('click', () => {
//                     contentSidebar.classList.remove('is-show');
//                 });
//             });
//         }
//     });
//     const items = document.querySelectorAll('.fwits-img-item');
//     const tabs = document.querySelectorAll('.fwits-tab-item'); // your tabs

//     tabs.forEach(tab => {
//         tab.addEventListener('click', () => {
//             const targetId = tab.getAttribute('data-href') || tab.getAttribute('data-id'); // get target ID from tab
//             const targetItem = document.querySelector(`.fwits-img-item[data-id="${targetId}"]`);
//             const current = document.querySelector('.fwits-img-item.is-active');

//             if (!targetItem) {return;} // safety check

//             // If clicked item is already active → slide out
//             if (current === targetItem) {
//                 current.classList.remove('is-active');
//                 current.classList.add('exit');
//                 setTimeout(() => current.classList.remove('exit'), 800);
//                 return;
//             }

//             // Slide out current active
//             if (current) {
//                 current.classList.remove('is-active');
//                 current.classList.add('exit');
//                 setTimeout(() => current.classList.remove('exit'), 800);
//             }

//             // Slide in clicked item
//             targetItem.classList.add('is-active');
//         });
//     });

// });

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.full-width-image-tabs-section');

    sections.forEach(section => {
        const tabSliderEl = section.querySelector('.fwits-tab-slider');
        const contentSliderEl = section.querySelector('.fwits-content-slider');
        const tabs = section.querySelectorAll('.fwits-tab-item');
        const images = section.querySelectorAll('.fwits-img-item');
        const contentSidebar = section.querySelector('.fwits-content-sidebar');
        const prevBtn = section.querySelector('.fwits-button-prev');
        const nextBtn = section.querySelector('.fwits-button-next');

        let currentActiveImage = section.querySelector('.fwits-img-item.is-active') || null;

        // Initialize Swipers
        const tabSwiper = new Swiper(tabSliderEl, {
            slidesPerView: 'auto',
            spaceBetween: 34,
        });

        const contentSwiper = new Swiper(contentSliderEl, {
            slidesPerView: 1,
            spaceBetween: 24,
            autoHeight: true,
            allowTouchMove: false,
            fadeEffect: { crossFade: true },
            navigation: { prevEl: prevBtn, nextEl: nextBtn },
            pagination: {
                el: section.querySelector('.fwits-pagination'),
                type: 'fraction',
                renderFraction: (currentClass, totalClass) =>
                    `<span class="${currentClass}"></span> of <span class="${totalClass}"></span>`,
            },
        });

        // --- Function to handle image transitions ---
        function setActiveImageById(targetId) {
            const newImage = section.querySelector(`.fwits-img-item[data-id="${targetId}"]`);
            if (!newImage) {return;}

            // If same image clicked again, do nothing
            if (currentActiveImage === newImage) {return;}

            // Remove lingering animation classes first
            images.forEach(img => img.classList.remove('slide-in', 'slide-out'));

            // Handle previous active image
            if (currentActiveImage && currentActiveImage !== newImage) {
                // Trigger exit animation
                currentActiveImage.classList.remove('is-active', 'slide-in');
                currentActiveImage.classList.add('exit');

                // Optional: remove the exit class after animation ends (clean-up)
                setTimeout(() => {
                    currentActiveImage.classList.remove('exit');
                }, 800); // match your CSS transition duration
            }

            // Wait a bit to let the exit animate, then activate new image
            setTimeout(() => {
                newImage.classList.remove('exit');
                newImage.classList.add('is-active', 'slide-in');
                setTimeout(() => newImage.classList.remove('slide-in'), 500);
                currentActiveImage = newImage;
            }, 100); // small delay for smoother transition
        }


        // --- Tab Clicks ---
        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => {
                if (tab.classList.contains('is-active')) {return;}

                const targetId = tab.getAttribute('data-href') || tab.getAttribute('data-id');
                if (!targetId) {return;}

                tabs.forEach(t => t.classList.remove('is-active'));
                tab.classList.add('is-active');

                // Update Swiper and Image
                contentSwiper.slideTo(index);
                setActiveImageById(targetId);
            });
        });

        // --- Swiper Slide Change (next/prev/pagination) ---
        contentSwiper.on('slideChange', () => {
            const currentIndex = contentSwiper.activeIndex;
            const activeTab = tabs[currentIndex];
            const targetId = activeTab?.getAttribute('data-href') || activeTab?.getAttribute('data-id');

            tabs.forEach(t => t.classList.remove('is-active'));
            if (activeTab) {activeTab.classList.add('is-active');}

            setActiveImageById(targetId);
            tabSwiper.slideTo(currentIndex);
        });

        // --- Sidebar open/close ---
        images.forEach(item => {
            const dragElements = item.querySelectorAll('.drag_element');
            dragElements.forEach(dragEl => {
                dragEl.addEventListener('click', () => {
                    if (contentSidebar) {contentSidebar.classList.add('is-show');}
                });
            });
        });

        const closeBtns = section.querySelectorAll('.fwits-content-sidebar .close-btn, .fwits-content-sidebar .fwits-overlay');
        if (contentSidebar && closeBtns.length) {
            closeBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    contentSidebar.classList.remove('is-show');
                });
            });
        }
    });
});
